import BaseClass from "../../libs/base/BaseClass";
import Util from "../../libs/util/Util";
import LtikeCommon from "../common/LtikeCommon";
import HotelSearchAreaClass from "./HotelSearchAreaClass";

export default class HotelDataClass extends BaseClass {
    constructor() {
        super();

        this.ITEM_MAX_COUNT = 30;

        this.total = 0;
        this.pageNumber = 1;
        this.sortType = "0";
        this.isPageLast = false;
        this.tools = null;

        this.EVENT_FIRST_CALL_END = "eventFirstCallEnd";
        this.EVENT_FILTER_CALL_END = "eventFilterCallEnd";
        this.EVENT_TOTAL_COUNT_CHANGE = "eventTotalCountChange";
        this.EVENT_DATA_ADD_LOAD = "eventDataAddLoad";

        this.EVENT_API_ERROR = "eventApiError";
        this.isFirstCall = true;
        this.isFilterCall = false;

        this.data = [];
        this.dataLoadStatus = [];
        this.filter = null;

        this.lastIndex = -1;
        this.lastPageNumber = -1;

        this.isAddpageCall = false;
    }

    firstCall(_params){
        this.isFirstCall = true;

        if(this.pageCallJqXhr) this.pageCallJqXhr.abort();

        this.reset();

        this.pageCallJqXhr = Util.apiCall({
                url:LtikeCommon.API.HOTEL_SEARCH+"?"+_params
            },
            (res)=>{
                if(res.errorMessage){
                    //window.alert(res.errorCode+":"+res.errorMessage);

                    this.jq.trigger(this.EVENT_API_ERROR,res);
                } else {
                    this.catalogid = res.catalog.response.catalogid;
                    this.accesskey = res.catalog.response.accesskey;

                    this.cp_data = {};
                    if(res.catalog.response.catalogdata.hotel.campaign){
                        const cp = Util.checkItems(res.catalog.response.catalogdata.hotel.campaign.campaignlist.campaignitem);
                        cp.forEach((c)=>{
                            this.cp_data[c.code] = c;
                        });
                    }

                    this.resetCallEnd(res);
                }
            },
            (res)=>{
                this.jq.trigger(this.EVENT_API_ERROR,res);
            }
        );
    }

    add(res){
        //console.log("add",res);
        const hotel = res.catalog.response.catalogdata.hotel.hotel;
        const items = hotel.hotelitemlist.hotelitem;

        this.pageNumber = (res.catalog.request.pagenumber)? parseInt(res.catalog.request.pagenumber) : 1 ;
        this.dataLoadStatus[this.pageNumber - 1] = true;

        let startCount = (this.pageNumber - 1) * this.ITEM_MAX_COUNT;

        const arr = Util.checkItems(items);
        arr.forEach((item,i)=>{
            this.data[startCount + i] = item;
        });

        //console.log("add",this.data);

        this.jq.trigger(this.EVENT_DATA_ADD_LOAD);
    }

    get(_n){
        const BLOCK_COUNT = HotelSearchAreaClass.BLOCK_COUNT;
        const start = _n * BLOCK_COUNT;
        const end = start + BLOCK_COUNT;
        //console.log("get",_n,start,end,this.data.length,BLOCK_COUNT*5);

        const mustLoadIndex = Math.floor(start/this.ITEM_MAX_COUNT);
        const mustLoadIndexPrev = (mustLoadIndex > 0)? mustLoadIndex - 1 : mustLoadIndex;
        const mustLoadIndexNext = (mustLoadIndex < this.dataLoadStatus.length - 1)? mustLoadIndex + 1 : mustLoadIndex;

        //console.log("get mustLoadIndex",mustLoadIndex,mustLoadIndexPrev,mustLoadIndexNext);

        if(!this.dataLoadStatus[mustLoadIndexPrev] || !this.dataLoadStatus[mustLoadIndex] || !this.dataLoadStatus[mustLoadIndexNext]){
            this.addPageCall(mustLoadIndex,true);
        }

        const mustLoadIndexCheckNext = Math.floor(end / this.ITEM_MAX_COUNT);

        if(!this.dataLoadStatus[mustLoadIndex] || !this.dataLoadStatus[mustLoadIndexCheckNext]){
            return [];
        } else {
            return this.data.slice(start,end);
        }
    }

    reset(){
        this.data = [];
    }

    filterCall(){
        this.isFilterCall = true;
        let params = '';
        params += 'catalogid='+this.catalogid;
        params += '&accesskey='+this.accesskey;
        params += '&pagenumber=1';

        params += '&hotelsort='+this.sortType;

        params += this.getToolsParams();

        this.reset();

        if(this.pageCallJqXhr) this.pageCallJqXhr.abort();

        Util.apiCall({
                url:LtikeCommon.API.HOTEL_FILTER+"?"+params
            },
            (res)=>{
                //console.log("filterCall",res);
                if(res.errorMessage){
                    //window.alert(res.errorCode+":"+res.errorMessage);
                    this.jq.trigger(this.EVENT_API_ERROR,res);
                } else {
                    this.resetCallEnd(res);
                }
            },
            (res)=>{
                this.jq.trigger(this.EVENT_API_ERROR,res);
            }
        );
    }

    resetCallEnd(res){
        this.pageNumber = 1;
        //console.log("resetCallEnd",res);

        if(res.filteritem || res.catalog.response.catalogdata.hotel.hotel.filteredhoteltotalcount){
            let total = 0;
            if(res.filteritem) {
                this.filter = res.filteritem.response;
                total = res.filteritem.response.catalogdata.hotel.hotel.filter.hotelnum;
            } else {
                total = res.catalog.response.catalogdata.hotel.hotel.filteredhoteltotalcount;
            }

            this.total = parseInt(total);
            this.lastIndex = Math.ceil(this.total/HotelSearchAreaClass.BLOCK_COUNT);
            this.lastPageNumber = Math.ceil(this.total/this.ITEM_MAX_COUNT);

            this.jq.trigger(this.EVENT_TOTAL_COUNT_CHANGE);

            this.dataLoadStatus = new Array(this.lastPageNumber).fill(false);
            //this.dataLoadStatus[0] = true;
            //console.log(this.dataLoadStatus);
        }

        this.add(res);

        //console.log(this.total,this.ITEM_MAX_COUNT);

        if(this.total > this.ITEM_MAX_COUNT){
            this.pageCall(2);
        } else {
            this.isPageLast = true;
            this.pageCallEnd();
        }
    }

    addPageCall(mustLoadIndex,isMore=false){
        //console.log("addPageCall",mustLoadIndex,this.lastPageNumber,this.isAddpageCall);

        if(this.pageCallJqXhr) this.pageCallJqXhr.abort();
        const mustPageNumber = mustLoadIndex + 1;

        const self = this;
        function nextPage(_callback){
            const index = mustPageNumber + 1;
            //console.log("nextPage",index,self.dataLoadStatus[index - 1]);
            if(!self.dataLoadStatus[index - 1]){
                self.pageCall(index,()=>{
                    _callback();
                });
            } else {
                _callback();
            }

        }
        function prevPage(_callback){
            const index = mustPageNumber - 1;
            //console.log("prevPage",index,self.dataLoadStatus[index - 1]);
            if(!self.dataLoadStatus[index - 1]){
                self.pageCall(index,()=>{
                    _callback();
                });
            } else {
                _callback();
            }
        }

        //mustのページを読み込む
        this.pageCall(mustPageNumber,()=>{
            const isNext = (mustPageNumber + 1 <= this.lastPageNumber);
            const isPrev = (mustPageNumber - 1 >= 1);

            //console.log("mustPageNumber",mustPageNumber,isNext,isPrev);

            //後ろのページを読み込む
            if(isNext){
                nextPage(()=>{
                    if(isPrev) {
                        prevPage(()=>{
                            this.isAddpageCall = false;
                        });
                    }
                });
            } else if(isPrev){
                prevPage(()=>{
                    this.isAddpageCall = false;
                });
            } else {
                this.isAddpageCall = false;
            }
        });
    }

    pageCall(_n,_callback=null){
        let params = '';
        params += 'catalogid='+this.catalogid;
        params += '&accesskey='+this.accesskey;
        params += '&pagenumber='+_n;
        params += '&hotelsort='+this.sortType;

        params += this.getToolsParams();

        //console.log("pageCall",params);
        this.pageCallJqXhr = Util.apiCall({
                url:LtikeCommon.API.HOTEL_FILTER+"?"+params
            },
            (res)=>{
                //console.log("pageCall:",_n,res);
                //this.pageNumber = _n;

                //this.dataLoadStatus[_n - 1] = true;

                if(res.errorMessage){
                    //window.alert(res.errorCode+":"+res.errorMessage);
                    this.jq.trigger(this.EVENT_API_ERROR,res);
                } else {
                    this.add(res);
                    this.pageCallEnd();
                    if(_callback) _callback();
                }
            },
            (res)=>{
                this.jq.trigger(this.EVENT_API_ERROR,res);
            }
        );
    }

    pageCallEnd(){
        //console.log("pageCallEnd",this.pageNumber,this.dataLoadStatus);
        if(this.isFirstCall){
            this.isFirstCall = false;
            this.jq.trigger(this.EVENT_FIRST_CALL_END);
        }

        if(this.isFilterCall){
            this.isFilterCall = false;
            this.jq.trigger(this.EVENT_FILTER_CALL_END);
        }
    }

    getToolsParams(){
        let params = '';
        const tools = this.tools;
        $('[name^="hfst"]',tools).filter(":checked").each((i,e)=>{
            const _this = $(e);
            params += `&${_this.attr("name")}=Y`;
        });

        $('[name=hfdispmode]',tools).filter(':checked').each((i,e)=>{
            const _this = $(e);
            params += `&${_this.attr("name")}=${_this.attr("value")}`;
        });

        const hfa = [];
        $('[name^="hffacility"]',tools).filter(":checked").each((i,e)=>{
            const _this = $(e);
            hfa.push(_this.val());
        });
        if(hfa.length > 0){
            params += `&hffacility=`+hfa.join(",");
        }

        const har = [];
        $('[name^="hfarea"]',tools).filter(":checked").each((i,e)=>{
            const _this = $(e);
            har.push(_this.val());
        });
        if(har.length > 0){
            params += `&hfarea=`+har.join(",");
        }

        const hfmin = $('[name="hfmin"]',tools).val();
        if(hfmin) params += '&hfmin='+hfmin;
        const hfmax = $('[name="hfmax"]',tools).val();
        if(hfmax) params += '&hfmax='+hfmax;

        //console.log("getToolsParams",params);

        return params;
    }

}